import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AddNewCustomer } from '../store/api/CustomerApi';
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';
import ModalMap from '../Common/ModalMap';
import { Button, Row } from 'react-bootstrap';
import { CheckLg, DashCircle, FileMinus, GeoAlt, PlusSquare } from 'react-bootstrap-icons';
import { getSystemSettings } from '../store/api/SystemSettingsAPI';

const RegisterCustomer = (props) => {
    //
    const dispatch = useDispatch();
    const [popMap, setMapPop] = useState({ show: false });
    const company = JSON.parse(localStorage.getItem("Company"));
    const isLoadingSaved = useSelector(state => state.loading?.isLoading);
    const { register, handleSubmit, errors } = useForm();
    const [isLoading, setLoading] = useState(false);
    const settingNames = ["Services_ChoosingLocationIsObligatory"];
    const { provinceList, cityList, zoneList, currentLocation, systemSettings } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            currentLocation: state.locationDataReducer.currentLocation,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const locationIsRequired = systemSettings?.find(s => s.SettingName === "Services_ChoosingLocationIsObligatory")?.SettingValue?.toLowerCase() === "true";
    const [otherInfoHeight, setOtherInfoHeight] = useState(locationIsRequired ? "auto" : "2px");
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID))
    }
    const loadZoneList = (cityID) => {
        dispatch(getZoneList(cityID));
    }
    useEffect(() => {
        dispatch(getAllProvinces());
        document.body.classList = "notMain";
        dispatch(getSystemSettings(settingNames));
    }, [])
    const history = useHistory();
    const checkNationalCode = (NationalCode) => {
        if (NationalCode.length == 10) {
            if (NationalCode == '1111111111' ||
                NationalCode == '0000000000' ||
                NationalCode == '2222222222' ||
                NationalCode == '3333333333' ||
                NationalCode == '4444444444' ||
                NationalCode == '5555555555' ||
                NationalCode == '6666666666' ||
                NationalCode == '7777777777' ||
                NationalCode == '8888888888' ||
                NationalCode == '9999999999') {
                return false;
            }
            let c = parseInt(NationalCode.charAt(9));
            let n = parseInt(NationalCode.charAt(0)) * 10 +
                parseInt(NationalCode.charAt(1)) * 9 +
                parseInt(NationalCode.charAt(2)) * 8 +
                parseInt(NationalCode.charAt(3)) * 7 +
                parseInt(NationalCode.charAt(4)) * 6 +
                parseInt(NationalCode.charAt(5)) * 5 +
                parseInt(NationalCode.charAt(6)) * 4 +
                parseInt(NationalCode.charAt(7)) * 3 +
                parseInt(NationalCode.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }

    }
    const onSubmit = (data) => {
        if (currentLocation) {
            if (currentLocation.lat && currentLocation.lat !== "")
                data.Latitude = currentLocation.lat;
            if (currentLocation.lng && currentLocation.lng !== "")
                data.Longtitude = currentLocation.lng;
        }
        dispatch(AddNewCustomer(data, () => {
            props.setRegister(false);
            history.push("/");
        }))
    }
    const cancelRequest = () => {
        props.setRegister(false);
        history.push("/");
    }
    function setHeight() {
        setOtherInfoHeight(otherInfoHeight === "auto" ? "2px" : "auto");
    }
    function showModalMap() {
        setMapPop({ show: true });
    }
    return (
        <div className="container-fluid mt-2">
            <img src={company?.CompanyLogo} style={{ marginTop: "10px", marginBottom: "10px" }} />
            <ModalMap popData={popMap} setPopData={setMapPop} location={{ lat: 35.6996, lng: 51.3380, zoom: 9 }} />
            <br />
            <div className="card">
                <div className="card-header" style={{ backgroundColor: "#bb1370", color: "white" }}> ثبت نام </div>
                <div className="card-body" style={{ backgroundColor: "#f9efef" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input ref={register()} name="CustomerId" type="hidden" />
                        <Row>
                            <div style={{ position: 'relative' }} className="form-group col-md-3">
                                <label> کد ملی </label>
                                <input className="form-control" placeholder="از کد ملی برای ورود به سیستم استفاده می شود" name="NationalCode" type="text" ref={register({ required: true, validate: checkNationalCode })} />
                                <span style={{ position: 'absolute', left: 0, top: '21px' }}>
                                    {isLoading && <Loader type="BallTriangle" color="red" height={15} width={15} />}
                                </span>
                                {errors.NationalCode && <small className="errors"> کد ملی معتبر نیست </small>}
                            </div>

                            <div className="form-group col-md-3">
                                <label> نام </label>
                                <input className="form-control" name="Name" ref={register({ required: true })} type="text" />
                                {errors.Name && <small className="errors"> نام اجباری است </small>}
                            </div>

                            <div className="form-group col-md-3">
                                <label> موبایل مشتری </label>
                                <input className="form-control" name="Mobile" placeholder="رمز عبور به این شماره پیامک خواهد شد" ref={register({ required: true })} type="text" />
                                {errors.Mobile && <small className="errors"> موبایل اجباری است </small>}
                            </div>
                        </Row>
                        <Row className='rowBorder mt-3'>
                            <div className='rowTitle' onClick={setHeight} style={{ cursor: "pointer" }}>
                                سایر اطلاعات
                                &nbsp;
                                {otherInfoHeight === "2px" && <PlusSquare size={17} className="hoverIcon" />}
                                {otherInfoHeight === "auto" && <FileMinus size={17} />}
                            </div>
                            <Row style={{ height: otherInfoHeight, overflow: "hidden" }}>
                                <div className="form-group col-md-3">
                                    <label>جنسیت</label>
                                    <select className="form-control" name="Type" ref={register({ required: true })} defaultValue="مرد">
                                        <option value=""> لطفا انتخاب کنید </option>
                                        <option value="مرد"> مرد </option>
                                        <option value="زن"> زن </option>
                                    </select>
                                    {errors.Type && <small className="errors"> جنسیت را وارد کنید </small>}
                                </div>
                                <div className="form-group col-md-3">
                                    <label> تلفن </label>
                                    <input className="form-control" name="Phone" ref={register()} type="text" />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>نام استان</label>
                                    <select className="form-control" name="ProvinceID" onChange={e => loadCityList(e.target.value)} ref={register({ required: locationIsRequired })}>
                                        <option value="">لطفا انتخاب کنید</option>
                                        {provinceList && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                    {errors.ProvinceID && <small className="errors">نام استان اجباری است</small>}
                                </div>
                                <div className="form-group col-md-3">
                                    <label>نام شهر</label>
                                    <select className="form-control" name="CityID" onChange={e => loadZoneList(e.target.value)} ref={register({ required: locationIsRequired })}>
                                        <option value="">انتخاب کنید</option>
                                        {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                    {errors.CityID && <small className="errors">نام شهر اجباری است</small>}
                                </div>
                                <div className="form-group col-md-3">
                                    <label>نام منطقه</label>
                                    <select className="form-control" name="ZoneID" ref={register({ required: locationIsRequired })}>
                                        <option value="">انتخاب کنید</option>
                                        {zoneList && Array.isArray(zoneList) && zoneList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                    {errors.ZoneID && <small className="errors">منطقه جفرافیایی اجباری است</small>}
                                </div>
                                <div className="form-group col-md-3">
                                    <label> آدرس </label>
                                    <input className="form-control" name="Address" ref={register({ required: true })} type="text" defaultValue="-" />
                                    <Button className='btn-input-tiny' onClick={showModalMap}><GeoAlt size={18} /></Button>
                                    {errors.Address && <small className="errors"> آدرس اجباری است </small>}
                                </div>
                            </Row>
                        </Row>
                        {!isLoadingSaved && <div className='mt-2'>
                            <Button className="group-Btn-large" variant='info' type='submit'><CheckLg />&nbsp;  ثبت نام  </Button>
                            <Button className="group-Btn-large" onClick={cancelRequest} variant='danger' size='15'><DashCircle />&nbsp;انصراف</Button>
                        </div>
                        }
                        {isLoadingSaved && <div className='mt-2' style={{color:"blue"}}><Loader type="BallTriangle" color="red" height={20} width={20} style={{display:"inline-block", marginLeft:"5px"}}/><label>لطفا کمی صبر کنید </label></div>}
                    </form>
                </div>
            </div>
        </div>
    )
}
export default RegisterCustomer;
